import { createReducer, on } from '@ngrx/store';
import * as Actions from './actions';
import * as RootActions from '../../actions';
import { ActiveAlarmCounterDto, AgGridColumnFilter, AgGridColumnSort, GroupedAlarmDto } from '@services/api/api.service';

export interface State {
  counters: ActiveAlarmCounterDto;
  alarms: {
    data: GroupedAlarmDto[];
    totalCount: number;
    isLoading: boolean;
    paginator: {
      page: number;
      pageSize: number;
    }
    filters: {
      qSearch?: string;
      sortModel?: AgGridColumnSort[];
      filterModel?: { [key: string]: AgGridColumnFilter; }
    };
  };
  selectedAlarm: {
    vin: string;
    data: GroupedAlarmDto[];
    totalCount: number;
    isLoading: boolean;
    paginator: {
      page: number;
      pageSize: number;
    }
    filters: {
      qSearch?: string;
      sortModel?: AgGridColumnSort[];
      filterModel?: { [key: string]: AgGridColumnFilter; }
    };
  };
}


export const initialState: State = {
  counters: {},
  alarms: {
    data: [],
    totalCount: 0,
    isLoading: false,
    paginator: {
      page: 1,
      pageSize: 10,
    },
    filters: {
      qSearch: '',
    },
  },
  selectedAlarm: {
    vin: '',
    data: [],
    totalCount: 0,
    isLoading: false,
    paginator: {
      page: 1,
      pageSize: 10,
    },
    filters: {
      qSearch: '',
    },
  },
};

export const selectAlarms = state => state.alarm.alarms;
export const selectAlarmsCounters = state => state.alarm.counters;
export const selectSelectedAlarm = state => state.alarm.selectedAlarm;


export const alarmsReducer = createReducer(
  initialState,
  on(RootActions.resetState, () => ({ ...initialState })),
  on(Actions.setAlarmsCounters, (state, { counters }) => ({ ...state, counters })),
  on(Actions.setAlarmsLoading, (state, { isLoading }) => ({
    ...state,
    alarms: {
      ...state.alarms,
      isLoading,
    },
  })),
  on(Actions.setAlarmsFilters, (state, { filters }) => ({
    ...state,
    alarms: {
      ...state.alarms,
      filters: {
        ...state.alarms.filters,
        ...filters,
      },
    },
  })),
  on(Actions.setAlarmsPaginator, (state, { paginator }) => ({
    ...state,
    alarms: {
      ...state.alarms,
      paginator,
    },
  })),
  on(Actions.setAlarmsList, (state, { response }) => ({
    ...state,
    alarms: {
      ...state.alarms,
      data: response.alarms,
      totalCount: response.total,
    },
  })),
  on(Actions.setSelectedAlarmLoading, (state, { isLoading }) => ({
    ...state,
    selectedAlarm: {
      ...state.selectedAlarm,
      isLoading,
    },
  })),
  on(Actions.setSelectedAlarmFilters, (state, { filters }) => ({
    ...state,
    selectedAlarm: {
      ...state.selectedAlarm,
      filters: {
        ...state.selectedAlarm.filters,
        ...filters,
      },
    },
  })),
  on(Actions.setSelectedAlarmPaginator, (state, { paginator }) => ({
    ...state,
    selectedAlarm: {
      ...state.selectedAlarm,
      paginator,
    },
  })),
  on(Actions.setSelectedAlarmList, (state, { response }) => ({
    ...state,
    selectedAlarm: {
      ...state.selectedAlarm,
      data: response,
      totalCount: response.length,
    },
  })),
  on(Actions.getSelectedAlarmList, (state, { vin }) => ({
    ...state,
    selectedAlarm: {
      ...state.selectedAlarm,
      vin,
    },
  })),
);


